import Auth from "@/store/auth";

class Fetch {
  run(url, method = "GET", data = null) {
    return new Promise(resolve => {
      let options = {
        method: typeof method !== "string" ? "GET" : method,
        headers: {
          Authorization: "Bearer " + Auth.getters.getJwt
        }
      };

      if (typeof data === "object" && method !== "GET") {
        options.body = JSON.stringify(data);
      }

      fetch(url, options).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
          });
          resolve([]);
        }
      });
    });
  }
}

export default new Fetch();
